<template>
  <div class="all_tasks_container" :class="{ reverse: isTranslate }">
    <div class="menu-wrapper" :class="{ not_reversed_scroll: isTranslate }">
      <ul class="sub-menu-dropup" :class="{ not_reversed_ul: isTranslate }">
        <li
          :class="{ active: kobiSelectedItem == index }"
          @click="kobiSelectedItem = index"
          :key="index"
          class="dropdown-item btn btn-block btn-light-gray dp"
          v-for="(item, index) in kobiTags"
        >
          <span class="for-scale">{{ item }}</span>
        </li>
      </ul>
    </div>

    <div class="styleCard" :class="{ gantt: selectedTaskGraphTab === 'GANT' }">
      <ul class="style-nav style2">
        <li
          v-for="tab in tabsList()"
          :key="tab.id"
          :class="{ active: selectedTaskGraphTab === tab.alias }"
          @click="
            () => {
              selectedTaskGraphTab = tab.alias;
            }
          "
        >
          <span class="tag-selected-tab" v-if="tab.id === 5 && tagTabRep">{{
            tagTabRep
          }}</span>
          <span v-else>
            <span v-if="tab.alias === 'ALL_TASKS' && loaderIcon"
              ><img class="loader-icon" src="img/icons/date-spinner.svg" />
            </span>
            {{ tab.name }}
          </span>
        </li>
      </ul>

      <div class="styleCardContent padding flex">
        <ul v-show="!userTagsViewMode" class="date-nav style3">
          <li
            v-for="tab in timeRanges"
            :key="tab.id"
            :class="{ active: selectedDateRange === tab.alias }"
            @click="
              () => {
                selectedDateRange = tab.alias;
              }
            "
          >
            {{ tab.name }}
          </li>
        </ul>
        <div class="flex" v-show="selectedTaskGraphTab === 'ACTIVE'">
          <div class="Counters_wraper">
            <div v-if="activeCounter" class="total_Counter">
              {{ "Total: " }}{{ activeCounter }}
            </div>
          </div>
          <canvas width="1" id="active-tasks-chart"></canvas>
        </div>

        <div class="flex" v-show="selectedTaskGraphTab === 'NO_COMP'">
          <div class="Counters_wraper">
            <div v-if="noCompCounter" class="total_Counter">
              {{ "Total: " }}{{ noCompCounter }}
            </div>
          </div>
          <canvas width="1" id="no-comp-tasks-chart"></canvas>
        </div>

        <div class="flex" v-show="selectedTaskGraphTab === 'COMP'">
          <div class="Counters_wraper">
            <div v-if="compCounter" class="total_Counter">
              {{ "Total: " }}{{ compCounter }}
            </div>
          </div>
          <canvas width="1" id="comp-tasks-chart"></canvas>
        </div>

        <div class="flex" v-show="selectedTaskGraphTab === 'ALL_TASKS'">
          <!--        <div class="Counters_wraper">-->
          <!--          <div v-if="allCounter" class="total_Counter">-->
          <!--            {{ "Total: " }}{{ allCounter }}-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="time-users-chart">
            <canvas width="1" id="all-tasks-chart"></canvas>
          </div>
          <div class="time-total-chart">
            <canvas width="1" id="all-tasks-total-chart"></canvas>
          </div>
        </div>

        <div class="flex" v-show="selectedTaskGraphTab === 'USERS_TAGS'">
          <div
            class="tree-tags-chart"
            v-show="
              !userTagsViewMode &&
                (checkPermissions(auth, [1, 2]) &&
                  queryForCharts.show_all_tasks)
            "
          >
            <div class="Counters_wraper">
              <div v-if="tagsCounter" class="total_Counter">
                {{ "Total: " }}{{ tagsCounter }}
              </div>
            </div>
            <canvas width="1" id="users-tags-chart"></canvas>
          </div>

          <div
            class="tree-tags-chart"
            v-show="
              (!userTagsViewMode &&
                (!checkPermissions(auth, [1, 2]) &&
                  !queryForCharts.show_all_tasks)) ||
                (checkPermissions(auth, [1, 2]) &&
                  !queryForCharts.show_all_tasks)
            "
          >
            <div class="Counters_wraper">
              <!--              <div v-if="oenTagsCounter" class="total_Counter">-->
              <!--                {{ "Total: " }}{{ oenTagsCounter }}-->
              <!--              </div>-->
            </div>
            <div id="users-own-tags-chart"></div>
          </div>

          <div class="campaign-chart" v-show="userTagsViewMode">
            <div class="sysChatActions">
              <button @click="userTagsViewMode = false">
                <i class="fas fa-arrow-left"></i>
              </button>
            </div>
            <div class="Counters_wraper">
              <div v-if="tagsTreeCounter" class="total_Counter">
                {{ "Total: " }}{{ tagsTreeCounter }}
              </div>
            </div>

            <div id="tags-tasks-chart"></div>
          </div>
        </div>

        <div class="flex" v-show="selectedTaskGraphTab === 'TASKS_TIME'">
          <!--        <ul v-show="!userTagsViewMode" class="date-nav style3">-->
          <!--          <li-->
          <!--              v-for="tab in taskTimeRanges"-->
          <!--              :key="tab.id"-->
          <!--              :class="{ active: selectedTaskDateRange === tab.alias }"-->
          <!--              @click="()=>{-->
          <!--                        selectedTaskDateRange = tab.alias;-->
          <!--                    }-->
          <!--                    "-->
          <!--          >-->
          <!--            {{ tab.name }}-->
          <!--          </li>-->
          <!--        </ul>-->
          <!--        <div class="Counters_wraper">-->
          <!--          <div v-if="TotalTimeCounter" class="total_Counter">-->
          <!--            {{ "Total Users: " }}{{ TotalTimeCounter }}-->
          <!--          </div>-->
          <!--&lt;!&ndash;            <div v-if="TotalTimeCounter || TotalTasksOnTimeCounter" class="total_Counter">&ndash;&gt;-->
          <!--&lt;!&ndash;            {{ "Total Tasks: " }}{{ TotalTasksOnTimeCounter }}&ndash;&gt;-->
          <!--&lt;!&ndash;            </div>&ndash;&gt;-->

          <!--        </div>-->
          <div class="time-users-chart">
            <canvas width="1" id="tasks-time-chart"></canvas>
          </div>
          <div class="time-total-chart">
            <canvas width="1" id="tasks-total-time-chart"></canvas>
          </div>
        </div>

        <div class="gantt" v-show="selectedTaskGraphTab === 'GANT'">
          <div class="gantt-style" id="gantt-tasks-chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../helpers/api/request";
import Chart from "chart.js";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import hoursFormatterUtil from "../../../../../mixins/system/hoursFormatterUtil";
import TagsMultiSelect from "../../../components/multiselects/TagsMultiSelect.component";

import CahartAnnot from "chartjs-plugin-annotation";

const NoCompTasksChartBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const CompTasksChartBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const ActiveTasksChartBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const AllTasksChartBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    },
    tooltips: {
      callbacks: {
        label: (value, index, values) => {
          getChartHoverDetails(value, index);
        }
      }
    }
  }
};
const UsersTagsChartBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const TimeChartBarPerc = {
  type: "bar",
  options: {
    tooltips: {
      enabled: true,
      mode: "single",
      callbacks: {
        label: (tooltipItems, data, value) => {
          return (
            data.datasets[tooltipItems.datasetIndex].label +
            ": " +
            hoursFormatter(tooltipItems.yLabel)
          );
        }
      }
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },

    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,
        font: {
          family: "Montserrat"
        },
        fontSize: 5,
        color: function(context) {
          var index = context.dataIndex;
          var value = context.dataset.data[index];
          return value < 0
            ? "red" // draw negative values in red
            : context.dataset.borderColor;

          //return context.dataset.borderColor;
        },
        formatter: function(value, index, values) {
          if (index.datasetIndex === 1) {
            return value.toFixed(0);
          }
          return value === 0 ? "" : value.toFixed(0);
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          // stacked: true,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 10,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          // stacked: true,
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 1,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },

    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

// const TimeChartBarPerc = {
//   type: "bar",
//   options: {
//     plugins: {
//       datalabels: {
//         // color: "white",
//         display: false
//       }
//     },
//     aspectRatio: 2,
//     // responsive:true,
//     scales: {
//       yAxes: [
//         {
//           stacked: true,
//           gridLines: {
//             drawBorder: false,
//             color: "transparent",
//             zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
//           },
//           ticks: {
//             padding: 0,
//             fontColor: "#44A2D2", //"#44A2D2",
//             fontFamily: "Montserrat",
//             fontSize: 10,
//             steps: 10,
//
//             callback: function(value, index, values) {
//               return value + " %";
//             },
//             beginAtZero: true
//             //min:0,
//             //max: 100
//           }
//         }
//       ],
//       xAxes: [
//         {
//           stacked: true,
//           gridLines: {
//             drawBorder: false,
//             color: "transparent",
//             zeroLineColor: "rgba(70,204,253,0.22)"
//           },
//           ticks: {
//             beginAtZero: true,
//             padding: 0,
//             fontColor: "#44A2D2",
//             fontFamily: "Montserrat",
//             fontSize: 10
//           }
//         }
//       ]
//     },
//     legend: {
//       labels: {
//         boxWidth: 20,
//         fontSize: 10
//         // display: false
//       }
//     },
//     tooltips: {
//       enabled: true,
//       mode: "single",
//       callbacks: {
//         label: function(tooltipItems, data) {
//           return tooltipItems.yLabel.toFixed(2) + "%";
//           // return '$' + data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
//         }
//       }
//     }
//   }
// };

export default {
  name: "TasksCharts.component",
  props: {
    isTranslate: {
      type: Boolean
    }
  },
  mixins: [hoursFormatterUtil],
  components: {
    // TagsMultiSelect,
  },
  data() {
    return {
      kobiTags: ["item 1", "item 2", "menu 3", "tasks 4", "item 5", "viki 6"],
      kobiSelectedItem: 0,
      NoCompTasksChartBar: NoCompTasksChartBar,
      CompTasksChartBar: CompTasksChartBar,
      ActiveTasksChartBar: ActiveTasksChartBar,
      AllTasksChartBar: {
        type: "bar",
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 15,
              bottom: 0
            }
          },
          plugins: {
            datalabels: {
              align: "end",
              anchor: "end",
              offset: -5,

              font: {
                family: "Montserrat"
              },
              fontSize: 9,
              color: function(context) {
                return context.dataset.borderColor;
              },
              formatter: function(value) {
                return value === 0 ? "" : value;
              }
            }
          },

          maintainAspectRatio: false,
          gradientColors: [
            "rgba(29,140,248,0.2)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  beginAtZero: true,
                  //display:false,
                  padding: 10,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 1
                }
              }
            ],
            xAxes: [
              {
                id: "bar-x-axis1",
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  padding: 1,
                  fontColor: "#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 10
                }
              }
            ]
          },
          legend: {
            display: false
          },

          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          },
          tooltips: {
            callbacks: {
              label: (value, index, values) => {
                let userId;
                if (value.label !== "Total") {
                  let idx = value.index;
                  userId = index.datasets[1].data[idx];
                } else {
                  userId = "ALL";
                }
                if (this.allTasksChartExpendDetails[userId]) {
                  let tags = [];
                  this.allTasksChartExpendDetails[userId].tags.forEach(tag => {
                    tags.push(`${tag.tag}:${tag.count}`);
                  });

                  let allData = [
                    "Tasks: " + this.allTasksChartExpendDetails[userId].count,
                    "Est ToT: " +
                      this.hoursFormatter(
                        this.allTasksChartExpendDetails[userId].estimated_time
                      ) +
                      ", Exc: " +
                      this.hoursFormatter(
                        this.allTasksChartExpendDetails[userId].total_time
                      ) +
                      ", Left: " +
                      this.hoursFormatter(
                        this.allTasksChartExpendDetails[userId].left_time
                      ),
                    "tags: " + tags
                  ];

                  return allData;
                }

                this.fetchAllTasksHoverDetails(userId);
              }
            },
            position: "nearest"
          }
        }
      },
      UsersTagsChartBar: UsersTagsChartBar,
      TimeChartBarPerc: {
        type: "bar",
        options: {
          tooltips: {
            enabled: true,
            mode: "single",
            callbacks: {
              label: (tooltipItems, data, value) => {
                return (
                  data.datasets[tooltipItems.datasetIndex].label +
                  ": " +
                  this.hoursFormatter(tooltipItems.yLabel)
                );
              }
            }
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 15,
              bottom: 0
            }
          },

          plugins: {
            datalabels: {
              align: "end",
              anchor: "end",
              offset: -5,
              font: {
                family: "Montserrat"
              },
              fontSize: 5,
              color: function(context) {
                var index = context.dataIndex;
                var value = context.dataset.data[index];
                return value < 0
                  ? "red" // draw negative values in red
                  : context.dataset.borderColor;

                //return context.dataset.borderColor;
              },
              formatter: function(value, index, values) {
                if (index.datasetIndex === 1) {
                  return value.toFixed(0);
                }
                return value === 0 ? "" : value.toFixed(0);
              }
            }
          },

          maintainAspectRatio: false,
          gradientColors: [
            "rgba(29,140,248,0.2)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                // stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  beginAtZero: true,
                  //display:false,
                  padding: 10,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 1
                }
              }
            ],
            xAxes: [
              {
                // stacked: true,
                id: "bar-x-axis1",
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  padding: 1,
                  fontColor: "#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 10
                }
              }
            ]
          },
          legend: {
            display: false
          },

          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          }
        }
      },

      ActiveTasksChartBuild: null,
      NoCompTasksChartBuild: null,
      CompTasksChartBuild: null,
      AllTasksChartBuild: null,
      UsersTagsChartBuild: null,
      TasksTimeChartBuild: null,
      TasksTimeTotalChartBuild: null,
      AllTasksTotalChartBuild: null,

      ArNoCompTaskData: [],
      ArCompTaskData: [],
      ArActiveTaskData: [],
      ArTagsTaskData: [],
      ArAllTaskData: [],
      ArGanttData: [],
      ArUsersTagsData: [],
      ArTasksTimeData: [],

      selectedTaskGraphTab: "ALL_TASKS",
      selectedDateRange: null,
      selectedTagDateRange: "TODAY",
      selectedTaskDateRange: "TODAY",

      reqNoComp: false,
      reqComp: false,
      reqActive: false,
      reqTags: false,
      reqAll: false,
      reqGantt: false,
      reqUsersTags: false,
      reqTasksTime: false,

      activeCounter: null,
      noCompCounter: null,
      compCounter: null,
      tagsCounter: null,
      allCounter: null,
      usersTagsCounter: null,
      tagsTreeCounter: null,
      TotalTimeCounter: null,
      TotalTasksOnTimeCounter: null,

      userTagsViewMode: false,
      showTagsTab: true,
      tasksGraphTabs: [
        // {
        //   id:1,
        //   name:"Active",
        //   alias:"ACTIVE"
        // },
        // {
        //   id:2,
        //   name:"Not Completed",
        //   alias:"NO_COMP"
        // },
        // {
        //   id:3,
        //   name:"Completed",
        //   alias:"COMP"
        // },
        // {
        //     id:4,
        //     name:"Tags",
        //     alias:"TAGS"
        // },
        // {
        //   id: 5,
        //   name: "Tags",
        //   alias: "USERS_TAGS"
        // },
        {
          id: 6,
          name: "All Tasks",
          alias: "ALL_TASKS"
        }
        // {
        //   id: 7,
        //   name: "Tasks Time",
        //   alias: "TASKS_TIME"
        // },
        // {
        //   id: 8,
        //   name: "Gant Chart",
        //   alias: "GANT"
        // }
      ],
      timeRanges: [
        {
          id: 1,
          name: "T",
          alias: "TODAY"
        },
        {
          id: 2,
          name: "Y",
          alias: "YESTERDAY"
        },
        {
          id: 3,
          name: "T-W",
          alias: "WEEK"
        },
        {
          id: 4,
          name: "L-W",
          alias: "LAST_WEEK"
        },
        {
          id: 5,
          name: "T-M",
          alias: "MONTH"
        },
        {
          id: 6,
          name: "L-M",
          alias: "LAST_MONTH"
        },
        {
          id: 7,
          name: "Q",
          alias: "QUARTER"
        },
        {
          id: 8,
          name: "H-Y",
          alias: "HALF_YEAR"
        },
        {
          id: 8,
          name: "Y",
          alias: "YEAR"
        }
      ],
      taskTimeRanges: [
        {
          id: 1,
          name: "T",
          alias: "TODAY"
        },
        {
          id: 2,
          name: "Y",
          alias: "YESTERDAY"
        },
        {
          id: 3,
          name: "T-W",
          alias: "WEEK"
        },
        {
          id: 4,
          name: "T-M",
          alias: "MONTH"
        },
        {
          id: 5,
          name: "L-M",
          alias: "LAST_MONTH"
        }
      ],
      queryObject: {},
      timeouts: null,
      fromTags: false,
      tagTabRep: null,
      tag_title: null,
      resetMsAfterFilter: false,
      resetMultiSelects: false,
      resetClicked: false,
      allTasksChartExpendDetails: {},
      loaderIcon: false
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("tasks", ["getChartQueryObject"]),
    ...mapState("tasks", ["queryForCharts", "resetQuery"])
    //
  },
  mounted() {
    //this.queryObject = this.$store.state.queryForCharts;
    //this.fetchActiveTasksChart();
    this.defaultPresets("YEAR");
  },
  created() {},
  watch: {
    resetQuery: function() {
      if (this.resetQuery) {
        this.selectedDateRange = null;
        //this.selectedTaskGraphTab = "USERS_TAGS";
      }
    },
    // selectedTaskDateRange:function(){
    //   this.fetchTasksTimeChart();
    // },
    getChartQueryObject: function() {
      this.allTasksChartExpendDetails = {};
      //  if (this.getChartQueryObject.tag_id.length === 1) {
      //    this.fetchTagsTasksChart(this.auth.user.id, "users-own-tags-chart");
      //  }
      //  if (this.selectedTaskGraphTab === "ACTIVE") {
      //    this.fetchActiveTasksChart();
      //  }
      //  if (this.selectedTaskGraphTab === "COMP") {
      //    this.fetchCompTasksChart();
      //  }
      //  if (this.selectedTaskGraphTab === "NO_COMP") {
      //    this.fetchNoCompTasksChart();
      //  }
      // // // if(this.selectedTaskGraphTab === 'TAGS'){
      //  //     this.fetchTagsTasksChart();
      //  // }
      //  if (this.selectedTaskGraphTab === "USERS_TAGS") {
      //    if (
      //      this.checkPermissions(this.auth, [1, 2]) &&
      //      this.queryForCharts.show_all_tasks
      //    ) {
      //      this.fetchUsersTagsChartData();
      //    } else {
      //      this.fetchTagsTasksChart(this.auth.user.id, "users-own-tags-chart");
      //    }
      //  }
      if (this.selectedTaskGraphTab === "ALL_TASKS") {
        this.fetchAllTasksChart();
      }
      // if (this.selectedTaskGraphTab === "GANT") {
      //   this.fetchGanttChartData();
      // }
      // if (this.selectedTaskGraphTab === "TASKS_TIME") {
      //   this.fetchTasksTimeChart();
      // }
    },
    // selectedTaskGraphTab: function() {
    //   if (this.selectedTaskGraphTab === "ACTIVE") {
    //     //this.$store.commit("tasks/setChartDataToTable", {groupId:this.selectedTaskGraphTab});
    //     this.fetchActiveTasksChart();
    //   }
    //   if (this.selectedTaskGraphTab === "COMP") {
    //     //this.$store.commit("tasks/setChartDataToTable", {groupId:this.selectedTaskGraphTab});
    //     this.fetchCompTasksChart();
    //   }
    //   if (this.selectedTaskGraphTab === "NO_COMP") {
    //     //this.$store.commit("tasks/setChartDataToTable", {groupId:this.selectedTaskGraphTab});
    //     this.fetchNoCompTasksChart();
    //   }
    //   //if(this.selectedTaskGraphTab === 'TAGS'){
    //   //     this.fetchTagsTasksChart();
    //   // }
    //   if (this.selectedTaskGraphTab === "USERS_TAGS") {
    //     this.fetchUsersTagsChartData();
    //     // this.userTagsViewMode = true;
    //     // this.fetchTagsTasksChart()
    //   }
    //   if (this.selectedTaskGraphTab === "ALL_TASKS") {
    //     this.fetchAllTasksChart();
    //   }
    //   if (this.selectedTaskGraphTab === "GANT") {
    //     this.fetchGanttChartData();
    //   }
    //   if (this.selectedTaskGraphTab === "TASKS_TIME" && !this.fromTags) {
    //     this.fetchTasksTimeChart();
    //   }
    //
    //   this.fromTags = false;
    // },
    selectedDateRange: function() {
      if (this.selectedDateRange) {
        this.$store.commit("tasks/setChartDataToTable", {
          dates: this.defaultPresets()
        });
      }
    }
  },
  methods: {
    defaultPresets(range = this.selectedDateRange) {
      if (range === "TODAY") {
        const today = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: today,
            end: today
          }
        };
      }
      if (range === "YESTERDAY") {
        const start = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD");

        const end = moment().format("YYYY-MM-DD");

        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_WEEK") {
        const start = moment()
          .subtract(1, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        const end = moment()
          .subtract(1, "weeks")
          .endOf("week")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const startMonth = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const startMonth = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_30_DAYS") {
        const start = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "QUARTER") {
        const start = moment()
          .startOf("quarter")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "HALF_YEAR") {
        const start = moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "YEAR") {
        const start = moment()
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
    },
    tabsList() {
      let tabsObj = this.tasksGraphTabs;

      // if(!this.getChartQueryObject.hasOwnProperty('show_all_tasks')){
      //   tabsObj = tabsObj.filter(i => i.alias !== "COMP");
      //   tabsObj = tabsObj.filter(i => i.alias !== "NO_COMP");
      //   tabsObj = tabsObj.filter(i => i.alias !== "ACTIVE");
      // }
      if (!this.showTagsTab) {
        tabsObj = tabsObj.filter(i => i.alias !== "USERS_TAGS");
      }

      return tabsObj;
    },

    fetchNoCompTasksChart() {
      this.ArNoCompTaskData = [];
      if (!this.reqNoComp) {
        this.reqNoComp = true;
        let tempParams = this.getChartQueryObject;
        let chartCanvasId = "no-comp-tasks-chart";

        apiClientCreator(`tasks/stats/users/tasks/0`)
          .get("", { params: tempParams })
          .then(res => {
            res.data.map(data => {
              this.ArNoCompTaskData.push(data);
            });
            this.createNoCompTasksChart(
              this.ArNoCompTaskData,
              chartCanvasId,
              this.NoCompTasksChartBar
            );
            this.reqNoComp = false;
            if (this.ArNoCompTaskData.length > 0) {
              this.noCompCounter = this.ArNoCompTaskData.reduce(
                (a, b) => a + b.count,
                0
              );
            }
          })
          .catch(err => {
            this.reqNoComp = false;
          });
      }
    },

    createNoCompTasksChart(Stats, canvasId, chartOpt) {
      let allData = Stats;
      let labels = [];
      let counts = [];
      let indexId = [];

      let opt = chartOpt.options;
      allData = allData.sort((a, b) => {
        return b.count - a.count;
      });
      allData.map(data => {
        if (data.count === 0) {
          return;
        } else {
          labels.push(data.user.full_name);
          counts.push(data.count);
          indexId.push(data.user.id);
        }
      });

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(208,37,53)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.NoCompTasksChartBuild) {
        this.NoCompTasksChartBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.NoCompTasksChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      ctx.onclick = evt => {
        this.clickOnUserChart(
          evt,
          indexId,
          this.NoCompTasksChartBuild,
          "NO_COMP"
        );
      };
    },

    fetchActiveTasksChart() {
      this.ArActiveTaskData = [];
      if (!this.reqActive) {
        this.reqActive = true;
        let tempParams = this.getChartQueryObject;
        let chartCanvasId = "active-tasks-chart";

        apiClientCreator(`tasks/stats/chart/active`)
          .get("", { params: tempParams })
          .then(res => {
            this.ArActiveTaskData = res.data;

            this.createActiveTasksChart(
              this.ArActiveTaskData,
              chartCanvasId,
              this.ActiveTasksChartBar
            );
            this.reqActive = false;

            this.activeCounter = this.ArActiveTaskData.total;
          })
          .catch(err => {
            this.reqActive = false;
          });
      }
    },

    createActiveTasksChart(Stats, canvasId, chartOpt) {
      let allData = Stats;
      let labels = [];
      let counts = [];
      let indexId = [];

      let opt = chartOpt.options;
      allData.map(data => {
        labels.push(data.user.full_name);
        counts.push(data.count);
        indexId.push(data.user.id);
      });

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(0,108,203)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.ActiveTasksChartBuild) {
        this.ActiveTasksChartBuild.destroy();
      }

      const ctx1 = document.getElementById(canvasId);
      this.ActiveTasksChartBuild = new Chart(ctx1, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      ctx1.onclick = evt => {
        this.clickOnUserChart(
          evt,
          indexId,
          this.ActiveTasksChartBuild,
          "ACTIVE"
        );
      };
    },

    fetchCompTasksChart() {
      this.ArCompTaskData = [];
      if (!this.reqComp) {
        this.reqComp = true;
        let tempParams = this.getChartQueryObject;
        let chartCanvasId = "comp-tasks-chart";

        apiClientCreator(`tasks/stats/users/tasks/1`)
          .get("", { params: tempParams })
          .then(res => {
            res.data.map(data => {
              this.ArCompTaskData.push(data);
            });
            this.createCompTasksChart(
              this.ArCompTaskData,
              chartCanvasId,
              this.CompTasksChartBar
            );
            this.reqComp = false;

            if (this.ArCompTaskData.length > 0) {
              this.compCounter = this.ArCompTaskData.reduce(
                (a, b) => a + b.count,
                0
              );
            }
          })
          .catch(err => {
            this.reqComp = false;
          });
      }
    },

    createCompTasksChart(Stats, canvasId, chartOpt) {
      let allData = Stats;
      let labels = [];
      let counts = [];
      let indexId = [];

      let opt = chartOpt.options;
      allData = allData.sort((a, b) => {
        return b.count - a.count;
      });
      allData.map(data => {
        if (data.count === 0) {
          return;
        } else {
          labels.push(data.user.full_name);
          counts.push(data.count);
          indexId.push(data.user.id);
        }
      });

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(0,203,19)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.CompTasksChartBuild) {
        this.CompTasksChartBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.CompTasksChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      ctx.onclick = evt => {
        this.clickOnUserChart(evt, indexId, this.CompTasksChartBuild, "COMP");
      };
    },

    fetchAllTasksChart() {
      this.ArAllTaskData = [];
      if (!this.reqAll) {
        this.reqAll = true;
        let tempParams = this.getChartQueryObject;
        let chartCanvasId = "all-tasks-chart";
        let totalCanvasId = "all-tasks-total-chart";

        apiClientCreator(`tasks/stats/all/tasks`)
          .get("", { params: tempParams })
          .then(res => {
            res.data.map(data => {
              this.ArAllTaskData.push(data);
            });

            this.createAllTasksChart(
              this.ArAllTaskData,
              chartCanvasId,
              this.AllTasksChartBar,
              totalCanvasId
            );
            this.reqAll = false;

            // if(this.ArAllTaskData.length > 0){
            //   this.allCounter = this.ArAllTaskData.reduce((a, b) => a + b.count, 0)
            // }
          })
          .catch(err => {
            this.reqAll = false;
          });
      }
    },

    createAllTasksChart(Stats, canvasId, chartOpt, totalCanvasId) {
      let allData = Stats;
      let labels = [];
      let counts = [];
      let indexId = [];
      let opt = chartOpt.options;
      allData = allData.sort((a, b) => {
        return b.count - a.count;
      });
      allData.map(data => {
        if (data.count === 0) {
          return;
        } else {
          labels.push(data.user.full_name);
          counts.push(data.count);
          indexId.push(data.user.id);
        }
      });

      let total = 0;
      if (counts.length > 0) {
        total = counts.reduce((a, b) => a + b, 0);
      }

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(176,196,222)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          },
          {
            type: "bar",
            label: "Tasks",
            data: indexId, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(176,196,222)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1",
            hidden: true
          }
        ]
      };

      const totalData = {
        labels: ["Total"],
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: [total], //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(119,136,153)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.AllTasksChartBuild) {
        this.AllTasksChartBuild.destroy();
      }

      if (this.AllTasksTotalChartBuild) {
        this.AllTasksTotalChartBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.AllTasksChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      const ctxTotal = document.getElementById(totalCanvasId);
      this.AllTasksTotalChartBuild = new Chart(ctxTotal, {
        height: 260,
        type: chartOpt.type,
        data: totalData,
        options: opt,
        plugins: [ChartDataLabels]
      });

      ctx.onclick = evt => {
        this.clickAllTasksChart(evt, indexId, this.AllTasksChartBuild);
      };
    },

    fetchTagsTasksChart(userId, chartCanvasIdC = "tags-tasks-chart") {
      this.ArTagsTaskData = [];
      if (!this.reqTags) {
        this.reqTags = true;
        let tempParams = this.getChartQueryObject;
        let colors = ["#e4fffb", "#bdffe7"];
        let chartCanvasId = chartCanvasIdC;
        let tempTagObj = [];

        apiClientCreator(`tasks/stats/user_tags/${userId}`)
          .get("", { params: tempParams })
          .then(res => {
            if (res.data[0]) {
              // if(res.data[0].tags.length === 0){
              //   this.showTagsTab = false;
              //   this.selectedTaskGraphTab = 'ALL_TASKS';
              // }else{
              //   this.showTagsTab = true;
              // }
              let allData = res.data[0];
              if (
                allData.tags.length > 0 &&
                this.getChartQueryObject.tag_id.length === 1
              ) {
                let oneTagObj = allData.tags.filter(
                  tag => tag.tag_id === this.getChartQueryObject.tag_id[0]
                );
                if (oneTagObj.length > 0) {
                  this.tagTabRep =
                    oneTagObj[0].tag + ` (` + oneTagObj[0].count + `)`;
                }
              } else {
                this.tagTabRep = null;
              }
              allData.tags.map(data => {
                tempTagObj.push({
                  name: data.tag,
                  size: data.count + 5,
                  value: data.count,
                  id: data.tag_id,
                  wrkd_time: this.hoursFormatter(data.wrkd_time),
                  est_time: this.hoursFormatter(data.est_time),
                  lft_time: this.hoursFormatter(data.lft_time)
                });
              });
              if (res.data.length > 0) {
                this.tagsTreeCounter = res.data[0].tags.reduce(
                  (a, b) => a + b.count,
                  0
                );
              } else {
                this.tagsTreeCounter = null;
              }
              this.ArTagsTaskData = [{ children: tempTagObj }];
              this.createTreeMapChart(
                this.ArTagsTaskData,
                chartCanvasId,
                colors
              );
              this.reqTags = false;
            }
          })
          .catch(err => {
            this.reqTags = false;
          });
      }
    },

    fetchUsersTagsChartData() {
      this.ArUsersTagsData = [];
      if (!this.reqUsersTags) {
        this.reqUsersTags = true;
        let tempParams = this.getChartQueryObject;
        let chartCanvasId = "users-tags-chart";

        apiClientCreator(`tasks/stats/tags/users`)
          .get("", { params: tempParams })
          .then(res => {
            res.data.map(data => {
              this.ArUsersTagsData.push(data);
            });
            if (res.data.length > 0) {
              this.tagsCounter = res.data.reduce((a, b) => a + b.count, 0);
            } else {
              this.tagsCounter = null;
            }
            this.createUsersTagsChart(
              this.ArUsersTagsData,
              chartCanvasId,
              this.UsersTagsChartBar
            );
            this.reqUsersTags = false;
            if (this.ArNoCompTaskData.length > 0) {
              this.noCompCounter = this.ArNoCompTaskData.reduce(
                (a, b) => a + b.count,
                0
              );
            }
          })
          .catch(err => {
            this.reqUsersTags = false;
          });
      }
    },

    createUsersTagsChart(Stats, canvasId, chartOpt) {
      let allData = Stats;
      let labels = [];
      let counts = [];
      let indexId = [];
      let opt = chartOpt.options;
      allData = allData.sort((a, b) => {
        return b.count - a.count;
      });
      allData.map(data => {
        if (data.count === 0) {
          return;
        } else {
          labels.push(data.user.full_name);
          counts.push(data.count);
          indexId.push(data.user.id);
        }
      });

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Tasks",
            data: counts, //onlineTrans,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(0,255,196)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          }
        ]
      };
      if (this.UsersTagsChartBuild) {
        this.UsersTagsChartBuild.destroy();
      }

      const ctx = document.getElementById(canvasId);
      this.UsersTagsChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      ctx.onclick = evt => {
        this.clickOnUserChart(evt, indexId, this.UsersTagsChartBuild, "TAGS");
      };
    },

    fetchTasksTimeChart() {
      this.ArTasksTimeData = [];
      if (!this.reqTasksTime) {
        this.reqTasksTime = true;
        let tempParams = this.getChartQueryObject;

        let colors = ["#e4fffb", "#bdffe7"];
        let MainChartCanvasId = "tasks-time-chart";
        let TotalChartCanvasId = "tasks-total-time-chart";

        apiClientCreator(`tasks/stats/tasks_times/users`)
          .get("", { params: tempParams })
          .then(res => {
            this.ArTasksTimeData = res.data;
            // if(res.data.length > 1){
            //   this.tasksTimeCounter = res.data.tags.reduce((a, b) => a + b.count, 0);
            // }else{
            //   this.tagsTreeCounter = null;
            // }
            // this.ArTasksTimeData = [{ children: tempTagObj }];
            this.createTasksTimeChart(
              this.ArTasksTimeData,
              MainChartCanvasId,
              TotalChartCanvasId,
              this.TimeChartBarPerc
            );
            this.reqTasksTime = false;
          })
          .catch(err => {
            this.reqTasksTime = false;
          });
      }
    },

    createTasksTimeChart(Stats, mainCanvasId, TotalChartCanvasId, chartOpt) {
      let allData = Stats;
      let wrkTime = [];
      let expTime = [];
      let lftTime = [];
      let totalDataTime = [];
      let totalexpTime = [];
      let totallftTime = [];
      let UserLables = [];
      let TotalLables = ["SPT", "EST", "LFT"];
      let opt = chartOpt.options;

      if (allData.users.length > 0) {
        this.TotalTimeCounter = allData.users.length;
      } else {
        this.TotalTimeCounter = null;
      }

      allData.users.map(data => {
        wrkTime.push(data.worked_time);
        expTime.push(data.expected_time);
        lftTime.push(data.left_time);
        UserLables.push(data.user.full_name);
      });

      totalDataTime.push(allData.total.wrk_time);
      totalDataTime.push(allData.total.exp_time);
      totalDataTime.push(allData.total.left_time);

      const data = {
        labels: UserLables,
        datasets: [
          {
            type: "bar",
            label: "Time Worked On",
            data: wrkTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(34,110,186)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            categoryPercentage: 0.9,
            barPercentage: 0.9
          },
          {
            type: "bar",
            label: "Expected Time",
            data: expTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(34,186,125)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            categoryPercentage: 0.9,
            barPercentage: 0.9
          },
          {
            type: "bar",
            label: "Time Left",
            data: lftTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(222,110,50)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            categoryPercentage: 0.9,
            barPercentage: 0.9
          }
        ]
      };

      const dataTotal = {
        labels: TotalLables,
        datasets: [
          {
            type: "bar",
            label: "Total",
            data: totalDataTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: [
              "rgb(34,110,186)",
              "rgb(34,186,125)",
              "rgb(222,110,50)"
            ],
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1"
          }
          // {
          //   type: "bar",
          //   label: "Expected Time",
          //   data:totalexpTime,
          //   fill: true,
          //   borderColor: "rgb(0, 13, 26)",
          //   backgroundColor: "rgb(34,186,125)",
          //   borderWidth: 0,
          //   borderDash: [],
          //   borderDashOffset: 0.0,
          //   maxBarThickness: 40,
          //   xAxisID: "bar-x-axis1"
          // },
          // {
          //   type: "bar",
          //   label: "Time Left",
          //   data:totallftTime,
          //   fill: true,
          //   borderColor: "rgb(0, 13, 26)",
          //   backgroundColor: "rgb(222,110,50)",
          //   borderWidth: 0,
          //   borderDash: [],
          //   borderDashOffset: 0.0,
          //   maxBarThickness: 40,
          //   xAxisID: "bar-x-axis1"
          // }
        ]
      };

      if (this.TasksTimeChartBuild) {
        this.TasksTimeChartBuild.destroy();
      }
      if (this.TasksTimeTotalChartBuild) {
        this.TasksTimeTotalChartBuild.destroy();
      }

      const ctx = document.getElementById(mainCanvasId);

      this.TasksTimeChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      const ctxTotal = document.getElementById(TotalChartCanvasId);
      this.TasksTimeTotalChartBuild = new Chart(ctxTotal, {
        height: 260,
        type: chartOpt.type,
        data: dataTotal,
        options: opt,
        plugins: [ChartDataLabels]
      });
    },

    createTreeMapChart(states, chartId, colors) {
      let allData = states;
      let canvasChartId = chartId;
      let chartColors = colors;

      let chart = anychart.treeMap(allData, "as-tree");
      $("#" + canvasChartId).html("");
      chart.container(canvasChartId);
      let customColorScale = anychart.scales.linearColor();
      customColorScale.colors(chartColors);
      chart.maxDepth(2);
      chart.headers(false);
      chart.colorScale(customColorScale);

      //functions

      if (
        canvasChartId === "tags-tasks-chart" ||
        canvasChartId === "users-own-tags-chart"
      ) {
        let group = "tag";
        chart.listen("mouseOver", function(e) {
          // change the cursor style
          document.body.style.cursor = "pointer";
        });
        chart.listen("mouseOut", function(e) {
          // set the default cursor style
          document.body.style.cursor = "auto";
        });
        chart.listen("pointClick", e => {
          let valueOfTasks = e.point.get("value");
          let id = e.point.get("id");
          if (valueOfTasks === 1) {
            this.$store.dispatch("tasks/getPreOpenTaskFromChart", {
              preOpen: true,
              newTagId: id
            });
          }
          this.$store.commit("tasks/setChartDataToTable", {
            tagId: id,
            groupId: group
          });
          this.fromTags = true;

          //this.selectedTaskGraphTab = "TASKS_TIME";
        });

        chart
          .tooltip()
          .format(
            "Total: {%value}\nWorked Time: {%wrkd_time}" +
              "\nEst Time: {%est_time}" +
              `\nLeft Time: {%lft_time}`
          );
      }
      chart.padding(0);
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    fetchGanttChartData() {
      this.ArGanttData = [];
      if (!this.reqGantt) {
        this.reqGantt = true;

        let chartCanvasId = "gantt-tasks-chart";
        let tempParams = {};
        let tempTagObj = [];

        apiClientCreator(`tasks/stats/all/gantt`)
          .get("", { params: tempParams })
          .then(res => {
            this.ArGanttData = [];
            res.data.map(data => {
              this.ArGanttData.push(data);
            });
            // = [{ children: tempTagObj }];
            this.createGanttChart(this.ArGanttData, chartCanvasId);
            this.reqGantt = false;
          })
          .catch(err => {
            this.reqGantt = false;
          });
      }
    },
    createGanttChart(GantData, canvasChart) {
      $("#" + canvasChart).html("");
      let DataToChart = [];

      GantData.map(data => {
        let protoType = {};
        let tasks = [];
        data.stats.map(statsData => {
          let tagsName = "";
          statsData.category.map(catName => {
            tagsName = tagsName + " " + catName.cat_type;
          });
          tasks.push({
            id: data.user.id + "_" + statsData.task.id,
            name: tagsName,
            actualStart: statsData.task.start_time,
            actualEnd: statsData.task.end_time
          });
        });
        protoType = {
          id: data.user.id,
          name: data.user.full_name,
          children: tasks
        };

        DataToChart.push(protoType);
      });

      // create a data tree
      let treeData = anychart.data.tree(DataToChart, "as-tree");

      // create a chart
      let chart = anychart.ganttProject();

      // set the data
      chart.data(treeData);

      // configure the second data grid column
      chart
        .dataGrid()
        .column(1)
        .setColumnFormat("name", {
          formatter: function(value) {
            return value.toUpperCase();
          },
          textStyle: { fontColor: "#64b5f6" },
          width: 130
        });

      // set the container id
      chart.container(canvasChart);
      // initiate drawing the chart
      chart.draw();
      // fit elements to the width of the timeline
      chart.fitAll();
      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },

    clickOnUserChart(evt, userIds, myChart, group) {
      const activePoints = myChart.getElementsAtEvent(evt);
      if (activePoints[0]) {
        const idx = activePoints[0]["_index"];
        let userId = userIds[idx];
        if (group === "TAGS") {
          this.userTagsViewMode = true;
          this.fetchTagsTasksChart(userId);
        }
        this.$store.commit("tasks/setChartDataToTable", {
          userId: userId,
          groupId: group
        });
      }
    },
    clickAllTasksChart(evt, userIds, myChart, group) {
      const activePoints = myChart.getElementsAtEvent(evt);
      if (activePoints[0]) {
        const idx = activePoints[0]["_index"];
        let userId = userIds[idx];

        this.$store.commit("tasks/setChartDataToTable", {
          userId: userId,
          groupId: group
        });
      }
    },

    fetchAllTasksHoverDetails(userId) {
      this.loaderIcon = true;
      const id = userId;
      let tempParams = this.getChartQueryObject;
      apiClientCreator(`tasks/stats/users/tasks/expended_data/${id}`)
        .get("", { params: tempParams })
        .then(res => {
          this.allTasksChartExpendDetails[id] = res.data;
          this.loaderIcon = false;
        })
        .catch(err => {
          this.loaderIcon = false;
        });
    }
  }

  // fetchTasksTimeChartPerc(){
  //   this.ArTasksTimeData = [];
  //   if(!this.reqTasksTime){
  //     this.reqTasksTime = true;
  //     let tempParams = {
  //       task_time_from: this.defaultPresets(this.selectedTaskDateRange).dateRange.start,
  //       task_time_at: this.defaultPresets(this.selectedTaskDateRange).dateRange.end
  //     };
  //
  //     let colors = ["#e4fffb", "#bdffe7"];
  //     let chartCanvasId = 'tasks-time-chart';
  //     let tempTagObj = [];
  //
  //
  //     apiClientCreator(`tasks/stats/tasks/times`)
  //         .get("", {params: tempParams}).then(res => {
  //
  //       this.ArTasksTimeData = res.data;
  //       // if(res.data.length > 1){
  //       //   this.tasksTimeCounter = res.data.tags.reduce((a, b) => a + b.count, 0);
  //       // }else{
  //       //   this.tagsTreeCounter = null;
  //       // }
  //       // this.ArTasksTimeData = [{ children: tempTagObj }];
  //       this.createTasksTimeChart(this.ArTasksTimeData,chartCanvasId,this.TimeChartBarPerc)
  //       this.reqTasksTime = false;
  //
  //
  //     }).catch(err=>{
  //       this.reqTasksTime = false;
  //     })
  //   }
  // },
  //
  // createTasksTimeChartPerc(Stats, canvasId, chartOpt){
  //   let allData = Stats;
  //   let perc = [];
  //   let counts = [];
  //   let estTime = [];
  //   let opt = chartOpt.options;
  //   let taskIds = [];
  //
  //   if(allData.tasks.length > 0 ){
  //     this.TotalTimeCounter = allData.total;
  //     this.TotalTasksOnTimeCounter = allData.tasks.length;
  //   }else{
  //     this.TotalTimeCounter = null;
  //     this.TotalTasksOnTimeCounter = null;
  //   }
  //   allData.tasks = allData.tasks.sort((a,b)=>{
  //
  //     return parseFloat(b.total_time) - parseFloat(a.total_time)
  //   })
  //
  //   allData.tasks.map(data=>{
  //     if(parseFloat(data.total_time) === 0){
  //       return
  //     }
  //     counts.push(parseFloat(data.total_time))
  //     let tempPerc = (data.total_time / allData.total) * 100;
  //     perc.push(
  //         tempPerc
  //     )
  //     taskIds.push("#"+data.task_id)
  //     estTime.push(data.estimated_time);
  //   })
  //
  //   //counts = counts.sort((a,b)=>{
  //   //
  //   //   return b - a
  //   // })
  //   //labels = [allData.total];
  //
  //
  //   const data = {
  //     labels: taskIds,
  //     datasets:[
  //       {
  //         type: "bar",
  //         label: "Time Worked On",
  //         data:counts,
  //         fill: true,
  //         borderColor: "rgb(0, 13, 26)",
  //         backgroundColor: "rgb(34,110,186)",
  //         borderWidth: 0,
  //         borderDash: [],
  //         borderDashOffset: 0.0,
  //         maxBarThickness: 40,
  //         xAxisID: "bar-x-axis1"
  //       },
  //       {
  //         type: "bar",
  //         label: "Percents",
  //         data:perc,
  //         fill: true,
  //         borderColor: "rgb(0, 13, 26)",
  //         backgroundColor: "rgb(34,186,125)",
  //         borderWidth: 0,
  //         borderDash: [],
  //         borderDashOffset: 0.0,
  //         maxBarThickness: 40,
  //         xAxisID: "bar-x-axis1"
  //       },
  //       {
  //         type: "bar",
  //         label: "Estimated Time",
  //         data:estTime,
  //         fill: true,
  //         borderColor: "rgb(0, 13, 26)",
  //         backgroundColor: "rgb(222,156,50)",
  //         borderWidth: 0,
  //         borderDash: [],
  //         borderDashOffset: 0.0,
  //         maxBarThickness: 40,
  //         xAxisID: "bar-x-axis1"
  //       }
  //     ]
  //
  //   };
  //
  //   if (this.TasksTimeChartBuild) {
  //     this.TasksTimeChartBuild.destroy();
  //   }
  //
  //   const ctx = document.getElementById(canvasId);
  //   this.TasksTimeChartBuild = new Chart(ctx, {
  //     height: 260,
  //     type: chartOpt.type,
  //     data: data,
  //     options: opt,
  //     plugins: [ChartDataLabels]
  //   });
  //
  // },
};
</script>

<style scoped>
.dropdown-item {
  /*margin-left: 15px;*/
  /*margin-right: 10px;*/
  height: 35px;
  min-height: 8%;
  outline: none;
  font-size: 12px;
  /*display: flex;*/
  /*text-align: left;*/
  transition: all 0.3s ease-in-out;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-delay: 0s;
  border-radius: 0px 5px 5px 5px;
  background-color: white;
  border: 1px solid #e5e4e4;
  /*position: relative;*/
  /*z-index: 1;*/
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.active {
  background-color: #c12fff;
  color: white;
}
.not_reversed_ul > li {
  /*transform: scaleX(-1);*/
}
.not_reversed_ul > li:hover {
  /*transform: translateX(14px) !important;*/
  /*transform: scaleX(-1);*/
}

not_reversed_scroll {
  overflow: hidden !important;
}

.not_reversed_scroll > li {
}
.all_tasks_container {
  padding-top: 12px;
  display: flex;
  /*flex-direction: column;*/
}
.reverse {
  flex-direction: row-reverse;
}

.not_reversed_scroll {
  transform: scaleX(1) !important;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
  transform: scaleX(-1);
}
.menu-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.menu-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 5px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
  transform: scaleX(-1);
  margin-left: 5px;
  max-height: 195px;
}
.Counters_wraper {
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 15px;
  top: 28px;
  z-index: 1;
}
.total_Counter {
  font-size: 1rem;
  font-weight: bold;
  float: right;
  margin-right: 10px;
}
.styleCard {
  /*margin-top: 12px;*/
  overflow: hidden;
  height: 100%;
  position: relative;
  font-family: Montserrat;
  /*margin-right: 5px;*/
  /*margin-left: 12px;*/
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  width: 100%;
}
.gantt {
  overflow: scroll;
}
.styleCard-OverFlow {
  overflow: scroll;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
  border-radius: 5px;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
                background: white;
              */
}
.style-nav.style2 li {
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 120px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0px;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(0px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.padding {
  padding: 1rem;
}

.campaign-chart {
  width: 100%;
  height: 160px;
}
.gantt-style {
  width: 100%;
  height: 160px;
}
.sysChatActions {
  position: absolute;
  bottom: 18px;
  left: 27px;
  border-top: 1px solid #ebeff2;
  z-index: 100;
}

.sysChatActions button:hover i {
  transform: translateX(0px);
}

.sysChatActions button img {
  transition: transform 0.3s ease;
}

.sysChatActions button {
  width: 35px;
  background: none;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 20px;
}
.sysChatActions:focus {
  outline: none;
}
.sysChatActions button:focus {
  outline: none;
}

.date-nav {
  max-width: 5%;
  min-width: 4%;
  max-height: 90%;
  min-height: 90%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 1;
}

.date-nav.style3 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
  display: flex;
  /*justify-content:center;*/
  align-items: center;
}

.date-nav.style3 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.date-nav li {
  max-width: 3%;
  min-width: 100%;
  max-height: 10%;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  text-align: left;
  vertical-align: middle;
  /*line-height: 25px;*/
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  margin-left: 3px;
}

.date-nav li:not(.empty):hover {
  transform: translateY(0px);
}

.date-nav li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.flex {
  display: flex;
  align-items: stretch;
  background-color: #fff;
  min-width: 100%;
  min-height: 90%;
  max-width: 100%;
}
.tree-tags-chart {
  min-width: 95%;
  max-height: 90%;
}
.time-users-chart {
  min-width: 85%;
  max-height: 90%;
}
.time-total-chart {
  min-width: 10%;
  max-height: 90%;
}
.full-width {
  min-width: 95%;
}
.tag-selected-tab {
  font-weight: bold;
}
.tags-tab-search {
  max-width: 150px !important;
  max-height: 30px !important;
}
</style>
